<template>
  <div class="actCalendar pos-r" v-if="actcalendar.list && actcalendar.list.length">
    <div class="actImg ml11 mr11">
      <img :src="actcalendar.bgurl" alt="" class="w-100 h-100 of-c" />
    </div>
    <div class="pos-a l0 r0 actDetail scroll-x">
      <swiper
        :options="actseckillSwiper"
        class="flex ai-c fw-n h-100 pl16 pr16"
        id="swiperActseckill"
      >
        <swiper-slide
          class="h-100 flex-s pos-r"
          v-for="(item, index) of actcalendar.list"
          :key="index"
        >
          <img :src="item.img_path" alt="" class="h-100 w-100 of-c" />
          <div
            :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=17'"
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { bannerClick, isWeixin } from '../../../assets/common/js/config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)

export default {
  props: {
    actcalendar: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    var that = this
    return {
      isWx: isWeixin() ? 1 : 0,
      actseckillSwiper: {
        observer: true,
        observeParents: true,
        freeMode: true,
        slidesPerView: 1.7023,
        spaceBetween: 7,
        pagination: {
          el: '#actseckillSwiperPagination',
          type: 'bullets'
        },
        on: {
          click: function () {
            that.bannerClick(
              that.actcalendar.list[this.clickedIndex],
              this.clickedIndex,
              'ACTCALENDAR-' + (this.clickedIndex + 1)
            )
          }
        }
      }
    }
  },
  methods: {
    bannerClick(item, index, flowArea) {
      bannerClick(item, index, flowArea, this, () => {
        this.dataCollection(item, index, flowArea)
      })
    },
    dataCollection(item, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? item.name : item.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : item.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? item.name : item.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.actCalendar {
  height: 1.49rem;
}
.actImg {
  height: 100%;
  border-radius: 0.1rem;
}
.actDetail {
  height: 1.04rem;
  bottom: 0.08rem;
  img {
    border-radius: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actCalendar.vue